import { HttpHandler } from 'msw'

import { createClient } from './createClient'
import { deleteClient } from './deleteClient'
import { getAllClients } from './getAllClients'
import { getClient } from './getClient'
import { updateClient } from './updateClient'

export const clients: HttpHandler[] = [
    createClient,
    deleteClient,
    getAllClients,
    getClient,
    updateClient,
]
